export default "__VITE_ASSET__01b645d1__"